export { default as withIntlApp } from './with-intl-app';
export { getIntlProps } from './intl-props';